import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { UploadFile, UploadsState } from "@js/types/uploads";

// Dispatched by WebSocketManager forwardAction.
export const UPLOAD_STATUS_UPDATE = "@websocket/FILE_UPLOAD_STATUS";

const initialState: UploadsState = {
  // Updates received via websocket-client.
  uploadsStatusUpdates: [],
};

export const uploadsSlice = createSlice({
  name: "uploads",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(UPLOAD_STATUS_UPDATE, (state, action) => {
      const { payload } = action as unknown as PayloadAction<UploadFile>;
      state.uploadsStatusUpdates.push(payload);
    });
  },
});
